// extracted by mini-css-extract-plugin
export default {"navbar_height":"65px","sidebar_width":"387px","identification_tabs_height":"36px","identification_header_height":"28px"};